import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import presenceClient from '../../services/PresenceClient';

// Mantiene abierta la conexión de presencia mientras hay sesión iniciada.
// Se reconecta cuando cambia el token (por ejemplo, al elegir colegio o cuenta particular).
const PresenceTracker = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const token = user?.token || '';

  useEffect(() => {
    if (isLoading) return undefined;

    if (isAuthenticated) {
      presenceClient.start();
    } else {
      presenceClient.stop();
    }

    return undefined;
  }, [isAuthenticated, isLoading, token]);

  useEffect(() => {
    const handleUnauthorized = () => {
      presenceClient.stop();
    };

    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => {
      window.removeEventListener('auth:unauthorized', handleUnauthorized);
      presenceClient.stop();
    };
  }, []);

  return null;
};

export default PresenceTracker;
